// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AutoCompleteResultRow-cls1___03358e1b1136ab6b9a4{/*!*/}.AutoCompleteResultRow-cls2___32b64ce9f49d1681032{font-weight:300;line-height:20px;color:#ccc;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AutoCompleteResultRow-cls1___03358e1b1136ab6b9a4",
	"cls2": "AutoCompleteResultRow-cls2___32b64ce9f49d1681032 AutoCompleteResultRow-cls1___03358e1b1136ab6b9a4"
};
export default ___CSS_LOADER_EXPORT___;
